import React, { useEffect, useState } from "react";
import { Paper, TextField, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import EmailTemplateEditor from "./EmailTemplateEditor";
import { saveEmailtemplate, getEmailTemplate } from "./EmailTemplatesConfig";
import { fetchMethod } from "./../../FetchMethod";
import { reject } from "lodash";
import { FadeLoader } from "react-spinners";
import SnackBarComponent from "../../SnackBar/SnackBar";
import Arrow from "./../../DumbAssets/Arrow";
import "./EmailTemplate.css";
const Platinum = "#e5e4e2";
// -------------------------------------REFRENCES----------------------------------------
// --------------------------------------------------------------------------------------
// ========== (1) :EmailTemplateMain  (ETM001)
// ========== (2) :EmailTemplateSaver (ETM002)
// ========== (3) :Form Container (EMTS004)
// ========== (4) :SnackBar Component (SNC0023)
// --------------------------------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    color: "dodgerblue",
    "& > *": {
      margin: theme.spacing(1),
      width: theme.spacing(160),
      height: "100%",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "dodgerblue",
    },
    "& label.Mui-focused": {
      color: "dodgerblue",
    },
  },
  ContextTextField: {
    paddingTop: "12px",
    paddingBottom: "12px",
    width: "100%",
    // marginRight: "27px",
  },
  ContextTextField2: {
    paddingTop: "12px",
    paddingBottom: "12px",
    width: "47%",
  },
  saveTemplateButton: {
    background: "#0071ce",
    width: "100px",
    "&:hover": {
      background: "#0071ce",
    },
  },
}));
//-----------EmailTemplateMain (ETM001)
const EmailTemplateMain = (props) => {
  const classes = useStyles();
  return (
    <div
      className={classes.root}
      style={{
        height: "auto",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        // alignItems: "center",
        // background: "white",
      }}
    >
      <EmailTemplateSaver {...props} />
    </div>
  );
};

//-----------EmailTemplateSaver (ETM002)
const EmailTemplateSaver = (props) => {
  if (!props.location.state) props.history.push("/email-templates");

  const {
    location: {
      state: { id, subject, message = "", name = "", kind = "", history } = {},
    },
  } = props;

  const classes = useStyles();
  const [TemplateObject, setTemplateObject] = useState(undefined);
  const [subjectContext, setSubject] = useState(subject);
  const [loading, setLoading] = useState(false);
  const [template, updateCurrentContext] = useState();
  const [open, setOpen] = useState(false);
  const [smsMessage, setMessage] = useState(
    message ? message.replace(/(<([^>]+)>)/gi, "") : message
  );
  //  message ? message.replace(/(<([^>]+)>)/gi, "") :
  const handleChange = (event) => {
    event.preventDefault();
    setSubject(event.target.value);
  };

  const handleSnackBarClose = () => {
    setOpen(false);
  };

  const updateTemplateObject = async (event) => {
    event.preventDefault();
    setLoading(true);
    // console.log("+++++", TemplateObject.message);
    let res;
    if (TemplateObject != undefined) {
      res = await fetchMethod(saveEmailtemplate, {
        obj: {
          id: id,
          message: TemplateObject.message,
          subject: subjectContext,
        },
      }).then((res) => res.json());
      // console.log("------SAVED", res);
    } else {
      res = await fetchMethod(saveEmailtemplate, {
        obj: {
          id: id,
          subject: subjectContext,
        },
      });
    }

    setOpen(true);

    setTimeout(() => {
      props.history.push({ pathname: "email-templates" });
    }, 1500);
    // window.location = "/email-templates";
    setLoading(false);
  };

  return (
    <div style={{ height: "auto", width: "75%", marginTop: "0px" }}>
      <ul className="emailPath">
        <li //onclick here
          onClick={() => {
            window.location = "/email-templates";
          }}
          style={{ cursor: "pointer" }}
        >
          Email Templates
        </li>
        <li>
          <Arrow />
        </li>
        <li>Edit Template</li>
      </ul>
      {/* <h2>Edit Template</h2> */}
      {/* LOADER */}
      {loading ? (
        <div className="Loader">
          <FadeLoader
            style={{ height: "15", width: "5", radius: "2" }}
            color={"#6FABF0"}
            loading={loading}
          />
        </div>
      ) : (
        ""
      )}
      {/* LOADER */}
      <h1 style={{ color: "black", marginBottom: "-32px" }}>
        Edit Email Template
      </h1>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "20px",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          className={classes.saveTemplateButton}
          onClick={updateTemplateObject}
        >
          Save
        </Button>
      </div>
      <Paper variant="outlined" elevation={1}>
        <div style={{ height: "80%", width: "70%", padding: "8px" }}>
          {/* ------- Form Container (EMTS004) --------  */}
          <div
            style={{
              margin: "12px",
              height: "100%",
              width: "98%",
              padding: "8px",
              // border: "1px solid #e0e0e0",
              // borderRadius: "3px",
            }}
          >
            <form noValidate autoComplete="off">
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  // justifyContent: "space-between",
                }}
              >
                <TextField
                  className={classes.ContextTextField}
                  id="standard-basic"
                  label="Template Name"
                  value={name}
                  // disabled={true}
                />
                {/* <TextField
                  className={classes.ContextTextField2}
                  id="standard-basic"
                  label="Template Code"
                /> */}
              </div>
              <div>
                <TextField
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  fullWidth={true}
                  id="standard-basic"
                  label="Subject"
                  value={subjectContext}
                />
              </div>
            </form>

            {/* ------- Form Container (EMTS004)--------  */}
          </div>

          <h5 style={{ margin: "15px", color: "dodgerblue", fontSize: "16px" }}>
            Compose Message
          </h5>
          {/* {kind.toLowerCase() === "sms" ? (
            ""
          ) : ( */}
          <div
            style={{
              margin: "12px",
              background: Platinum,
              height: "100%",
              width: "98%",
              padding: "8px",
              border: "1px solid #e0e0e0",
              borderRadius: "3px",
            }}
          >
            <div>
              <h5 style={{ margin: "8px" }}>
                You can use below tags for dynamic contents:
              </h5>
              {/* All Tags */}
              <div style={{ margin: "8px" }}>
                <h7
                  style={{
                    color: "dodgerblue",
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  First Name={"{{firstname}}"} &nbsp; &nbsp; &nbsp; Last Name=
                  {"{{lastname}}"} &nbsp; &nbsp; &nbsp; Physician=
                  {"{{physician}}"} &nbsp; &nbsp; &nbsp; Site ID={"{{SiteID}}"}&nbsp;
                  &nbsp; &nbsp; Assistant Name={"{{assistant}}"} &nbsp; &nbsp;
                  &nbsp; Email= {"{{email}}"}&nbsp; &nbsp; &nbsp; Password=
                  {"{{password}}"}&nbsp; &nbsp; Intervapor Id=
                  {"{{InterVaporID}}"}&nbsp; Site Name={"{{SiteName}}"}&nbsp;
                  &nbsp; &nbsp; CT Series UID={"{{SeriesUID}}"}&nbsp; &nbsp;
                  &nbsp; CT Acquisition Date={"{{CTAqDate}}"}&nbsp; &nbsp;
                  &nbsp; CT Receipt Date={"{{CTReceiptDate}}"}&nbsp; &nbsp;
                  &nbsp; One Time Password={"{{otp}}"}&nbsp; &nbsp; &nbsp;
                </h7>
              </div>
            </div>
          </div>
          {/* )} */}
          {/* SnackBarComponent (SNC0023)*/}
          {open ? (
            <SnackBarComponent
              severity={"success"}
              open={open}
              alertmsg={"Template Saved Successfully !"}
              handleClose={handleSnackBarClose}
              className="addUserSnackBar"
            />
          ) : (
            ""
          )}
          {/* SnackBar Component (SNC0023) */}
          <div style={{ margin: "12px", height: "100%", width: "98%" }}>
            <Paper variant="outlined">
              {kind.toLowerCase() === "sms" ? (
                <TextField
                  style={{ width: "100%" }}
                  className="sms-textarea"
                  onChange={(e) => {
                    setMessage(e ? e.target.value : "");
                    setTemplateObject({ message: e ? e.target.value : "" });
                  }}
                  // onChange={(e) => setTemplateObject({messgae:e ? e.target.value : ""})}
                  multiline
                  value={smsMessage}
                  variant="outlined"
                />
              ) : (
                <EmailTemplateEditor
                  setTemplateObject={setTemplateObject}
                  message={message}
                />
              )}
            </Paper>
          </div>
        </div>
      </Paper>
    </div>
  );
};

export default EmailTemplateMain;
